import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import "./layout.css"
import withSizes from "react-sizes"
import breakpoints, { BreakpointValues } from "./breakpoints"

import { LayoutContainer, DisableBodyScroll } from "./layout.style"
import Sidebar from "./navigation/sidebar"
import Header from "./navigation/header"

export const UIContext = React.createContext()

const Layout = ({
  children,
  breakpoint,
  location,
  showBackground,
  staticHeader = false,
  contactLightbox = false,
  bannerText = "",
}) => {
  const [UIState, setUIState] = useState({
    showSidebarNavigation: false,
    clientLoaded: false,
    disableBodyScroll: false,
    disableAnimations: false,
    location,
    breakpoint,
  })

  useEffect(() => {
    setUIState((prevState) => ({
      ...prevState,
      breakpoint,
      showSidebarNavigation:
        prevState.showSidebarNavigation && !(breakpoint === "lg"),
    }))
  }, [breakpoint])

  useEffect(() => {
    if (typeof window !== "undefined") {
      setUIState((prevState) => ({
        ...prevState,
        clientLoaded: true,
        disableAnimations: window.scrollY > 1000,
      }))
    }
    return () =>
      setUIState((prevState) => ({
        ...prevState,
        clientLoaded: false,
      }))
  }, [])

  return (
    <UIContext.Provider value={{ state: UIState, dispatch: setUIState }}>
      <LayoutContainer>
        <DisableBodyScroll
          enabled={
            UIState.disableBodyScroll ||
            (UIState.showSidebarNavigation &&
              window.matchMedia(`@media(max-width: ${breakpoints.lgPlus})`))
          }
        />
        <Header
          showBackground={showBackground}
          staticHeader={staticHeader}
          contactLightbox={contactLightbox}
          bannerText={bannerText}
        />
        <Sidebar />
        {children}
      </LayoutContainer>
    </UIContext.Provider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

const getBreakpoint = (width) => {
  if (!width || width >= BreakpointValues.lg) {
    return "lg"
  } else if (width >= BreakpointValues.md && width < BreakpointValues.lg) {
    return "md"
  } else {
    return "sm"
  }
}

const mapSizesToProps = ({ width }) => ({
  breakpoint: getBreakpoint(width),
})

export default withSizes(mapSizesToProps)(Layout)
